/**
 * Sidebar navigation icon markup.
 *
 * `puro-sidebar-navigation` accepts the icon as an inline HTML string ([innerHTML]),
 * not a `puro-icon` component, so we reference the kit's hosted SVG asset files
 * (served from `src/assets/icons/`, the same files `puro-icon` consumes) instead of
 * duplicating their path data. The kit assets carry Purolator blue (#001996) baked in,
 * matching the sidebar's resting icon color.
 */

/**
 * Builds an `<img>` string for a hosted kit icon asset sized for the sidebar icon slot.
 * @param asset SVG file name under `assets/icons/`.
 */
function sidebarIcon(asset: string): string {
  return `<img src="assets/icons/${asset}" alt="" width="20" height="20" />`;
}

/** truck — Start Shipping */
export const SIDEBAR_START_SHIPPING_ICON = sidebarIcon('truck.svg');

/** clock-time — Get Estimates */
export const SIDEBAR_CLOCK_ICON = sidebarIcon('clock-time.svg');

/** box-seam-shipment-package — Track Shipments */
export const SIDEBAR_TRACK_SHIPMENTS_ICON = sidebarIcon('box-seam-shipment-package.svg');

/** geo-location-pin — Locations */
export const SIDEBAR_LOCATION_ICON = sidebarIcon('geo-location-pin.svg');
